import LabelValueItem from "./components/LabelValueItem"

import "./style.scss"

const LabelValueList = ({ data }) => (
  <div className="labelInfoList">
    {data.map(
      ({ label, value, type }, index) =>
        value && (
          <LabelValueItem label={label} value={value} type={type} key={index} />
        )
    )}
  </div>
)

export default LabelValueList
